import { logError } from '@/logger'
import { OlympusClient } from '@/OlympusClient'

const ME2_EDIT_PUSH_TIMEOUT_MS = 10_000

/**
 * Best-effort push of an edited custom campaign's desired state to ME2. Runs
 * after the ME1 edit commits; failures are logged, never blocking (ME1 is the
 * source of truth).
 * @param campaignId the one-time campaign being edited
 * @param edit the convergent desired state
 * @param edit.subject the edited email subject line
 * @param edit.locationId the edited audience location scope (null = brand-wide)
 */
export async function sendMe2ConvergentEdit(
  campaignId: string,
  edit: { subject?: string; locationId?: string | null }
): Promise<void> {
  try {
    await OlympusClient.marketing.v1.campaigns.campaign.editMe2CustomCampaign({
      body: edit,
      params: { campaignId },
      signal: AbortSignal.timeout(ME2_EDIT_PUSH_TIMEOUT_MS),
    })
  } catch (error) {
    logError(error, {
      campaignId,
      convergenceFailed: true,
      feature: 'me2-convergent-edit',
    })
  }
}
